import { NPopover } from 'naive-ui'

/**
 * Truncate `value` to display a maximum of `maxLength` characters. In addition, a popover is added, so that the full value can be seen on hover.
 */
export default (value: string | undefined | null, maxLength: number) => h(NPopover, {}, {
  default: () => h('div', { class: 'flex flex-col gap-2' }, value ?? ''),
  trigger: () => h('div', { style: { width: `${maxLength}px` }, class: 'truncate' }, value ?? ''),
})
